import App from 'app/app.js';

function LtCyopDirective($window, $document) {
  return {
    restrict: 'E',
    scope: {
      index: '=',
      onSelect: '&',
      selectedSheetIndex: '=',
      selectedItems: '=',
      orderLineDetail: '=',
      onSelectLook: '&',
      isCustomizable: '=',
      customizeItem: '&',
      selectedOrderLineDetail: '=',
      isRemovable: '=',
      removeItem: '&'
    },
    template:
      '<div class="size" ng-show="!orderLineDetail.item && selectedSheetIndex !== index">' +
      '    <div class="choose-item-container">' +
      '       <img ng-click="onClickSelect(index)" data-id="button" src="assets/images/choose-item.jpg">' +
      '    </div>' +
      '    <a class="btn lt-btn" data-toggle="modal" data-target="#select-size" ' +
      '        ng-click="onClickSelect(index)" data-test-choose-sheet-item-btn data-id="button">' +
      '              <img class="cyop-sheet-icon" src="assets/images/choose-item.svg"/> ' +
      '              <span class="cyop-sheet-text" lt-translate="CYOP_CHOOSE_ITEM"></span>' +
      '    </a>' +
      '</div>' +
      '<div ng-class="{\'customize-selection\' : orderLineDetail.item}">' +
      '   <lt-custom-sheet order-line-detail="orderLineDetail" ng-show="(orderLineDetail.item.lookSelectionAllowed) && selectedSheetIndex !== index"></lt-custom-sheet>' +
      '   <div ng-show="orderLineDetail.item && !orderLineDetail.item.lookSelectionAllowed && selectedSheetIndex !== index">' +
      '       <h5 class="sheet-content-item-title"><b ng-bind="orderLineDetail.item | ItemDescFilter" class="ng-binding"></b></h5>' +
      '       <div class="addon-sheet-container">' +
      '           <div class="sheet-content" ' +
      "               ng-class=\"{portrait: !orderLineDetail.look || orientation === 'PORTRAIT', landscape: !!orderLineDetail.look && orientation === 'LANDSCAPE'}\">" +
      '               <div><img ng-src="{{selectedItems[index].image}}" alt="{{orderLineDetail.item | ItemDescFilter}}" class="item"/></div>' +
      '           </div>' +
      '       </div>' +
      '   </div>' +
      '   <div class="sheet-change">' +
      '       <a class="btn cyop-look-btn " ng-show="isCustomizable && !ctrl.isEdit(orderLineDetail.item)" ' +
      '          ng-click="ctrl.onCustomizeItem(orderLineDetail, index)" data-test-customize-btn data-id="button" > ' +
      '              <img class="cyop-sheet-icon" src="assets/images/personalization.svg"/> ' +
      '              <span class="cyop-sheet-text" lt-translate="EDIT_PERSONALIZATION"></span>' +
      '       </a>' +
      '       <a class="btn cyop-look-btn" ' +
      '          ng-show="isCustomizable && ctrl.isEdit(orderLineDetail.item)" ' +
      '          ng-click="ctrl.onCustomizeItem(orderLineDetail, index)" data-id="button">' +
      '              <img class="cyop-sheet-icon" src="assets/images/personalization.svg"/> ' +
      '              <span class="cyop-sheet-text" lt-translate="EDIT_PERSONALIZATION"></span>' +
      '       </a>' +
      '       <a class="btn cyop-look-btn" ' +
      '          ng-show="orderLineDetail.item.lookSelectionAllowed && selectedSheetIndex !== index" ' +
      '          data-ng-click="ctrl.selectLook(orderLineDetail, index)" data-test-choose-look-btn>' +
      '              <img class="cyop-background-icon" src="assets/images/change-background.svg"/> ' +
      '              <span class="cyop-sheet-text" lt-translate="CHANGE_BACKGROUND"></span> ' +
      '       </a>' +
      '       <div class="change-item-container" ng-show="orderLineDetail.item && selectedSheetIndex !== index">' +
      '           <a class="change-item" lt-translate="CYOP_CHANGE"' +
      '              ng-click="onClickSelect(index)" data-id="button"></a>' +
      '           <a ng-if="isRemovable" class="change-item" lt-translate="REMOVE_LINK" ' +
      '              ng-click="ctrl.onRemoveItem(index)" data-id="button">' +
      '           </a>' +
      '       </div>' +
      '   </div>' +
      '</div>',

    link: function (scope, element, attrs, ctrl) {
      scope.onClickSelect = function (index) {
        // scroll to the element
        var scrollTop =
          element[0].getBoundingClientRect().top +
          ($window.pageYOffset || $document.scrollTop()) -
          ($document.clientTop || 0);
        $document.scrollTop(scrollTop);
        ctrl.onClickSelect(index);
      };
    },
    controller: 'LtCyopCtrl',
    controllerAs: 'ctrl'
  };
}

App.directive('ltCyop', ['$window', '$document', LtCyopDirective]);
